import { setupNeedOf, type SetupNeed } from "@shared/connectors/setupNeed";
import { useConnectors } from "@/hooks/use-connectors";

/**
 * #2481: what a connection still needs to finish its setup, in its connector's words (a report
 * connection is asked for a report, never a table). Reads the connector catalog the screen already
 * holds, so a row names its need without a request of its own.
 */
export function useSetupNeed(
  connectorName: string | undefined,
  selectedCount: number | undefined,
): SetupNeed {
  const connectors = useConnectors();
  const reports =
    connectors.data?.find((connector) => connector.name === connectorName)?.reportsConnector ===
    true;
  return setupNeedOf(reports, selectedCount ?? 0);
}
